import { all, call, put, takeEvery, fork } from 'redux-saga/effects';
import { fetchJSON } from '../../helpers/api';
import {
  getLoansSuccess,
  getLoansFailure,
  get60DayLoansSuccess,
  get60DayLoansFailure,
  getCashFlowLoansSuccess,
  getCashFlowLoansFailure,
  getLoanSuccess,
  getLoanFailure,
  getLoanMaturityReportSuccess,
  getLoanMaturityReportFailure,
} from './actions';
import {
  GET_LOANS,
  GET_60_DAY_LOANS,
  GET_CASH_FLOW_LOANS,
  GET_LOAN,
  GET_LOAN_MATURITY_REPORT,
} from './constants';

const SERVER_URL = process.env.REACT_APP_KDM_API_ENDPOINT;

// Get Loans
function* getLoansSaga({}) {
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  try {
    const response = yield call(fetchJSON, `${SERVER_URL}/Loan/GetLoans`, options);
    yield put(getLoansSuccess(response));
  } catch (error) {
    let message;
    if (error.statusCode) {
      const errorDesc = (error.error && error.error.description) ? error.error.description : null;
      switch (error.statusCode) {
        case 500:
          message = 'Internal Server Error';
          break;
        case 401:
          message = errorDesc || 'Invalid credentials UNAUTHENTICATED';
          break;
        default:
          message = errorDesc || 'An error occurred';
      }
    } else {
      message = (error.description || 'An unknown error occurred');
    }
    yield put(getLoansFailure(message));
  }
}

function* get60DayLoansSaga({ }) {
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  try {
    const response = yield call(fetchJSON, `${SERVER_URL}/Loan/Get60DaysLoanReport`, options);
    yield put(get60DayLoansSuccess(response));
  } catch (error) {
    let message;
    if (error.statusCode) {
      const errorDesc = (error.error && error.error.description) ? error.error.description : null;
      switch (error.statusCode) {
        case 500:
          message = 'Internal Server Error';
          break;
        case 401:
          message = errorDesc || 'Invalid credentials UNAUTHENTICATED';
          break;
        default:
          message = errorDesc || 'An error occurred';
      }
    } else {
      message = (error.description || 'An unknown error occurred');
    }
    yield put(get60DayLoansFailure(message));
  }
}

//get Cash Flow Loans
function* getCashFlowLoans() {
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  try {
    const response = yield call(fetchJSON, `${SERVER_URL}/Loan/GetCashFlowReport`, options);
    yield put(getCashFlowLoansSuccess(response));
  } catch (error) {
    let message;
    if (error.statusCode) {
      const errorDesc = (error.error && error.error.description) ? error.error.description : null;
      switch (error.statusCode) {
        case 500:
          message = 'Internal Server Error';
          break;
        case 401:
          message = errorDesc || 'Invalid credentials UNAUTHENTICATED';
          break;
        default:
          message = errorDesc || 'An error occurred';
      }
    } else {
      message = (error.description || 'An unknown error occurred');
    }
    yield put(getCashFlowLoansFailure(message));
  }
}

// Get Loan
function* getLoanSaga({ payload: { loanId } }) {
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  try {
    const response = yield call(fetchJSON, `${SERVER_URL}/Loan/GetLoanDetails/${loanId}`, options);
    yield put(getLoanSuccess(response));
  } catch (error) {
    let message;
    if (error.statusCode) {
      const errorDesc = (error.error && error.error.description) ? error.error.description : null;
      switch (error.statusCode) {
        case 500:
          message = 'Internal Server Error';
          break;
        case 401:
          message = errorDesc || 'Invalid credentials UNAUTHENTICATED';
          break;
        default:
          message = errorDesc || 'An error occurred';
      }
    } else {
      message = (error.description || 'An unknown error occurred');
    }
    yield put(getLoanFailure(message));
  }
}

//get Maturity Report
function* getMaturityReportSaga() {
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  try {
    const response = yield call(fetchJSON, `${SERVER_URL}/Loan/GetSixMonthLoanReport`, options);
    yield put(getLoanMaturityReportSuccess(response));
  } catch (error) {
    let message;
    if (error.statusCode) {
      const errorDesc = (error.error && error.error.description) ? error.error.description : null;
      switch (error.statusCode) {
        case 500:
          message = 'Internal Server Error';
          break;
        case 401:
          message = errorDesc || 'Invalid credentials UNAUTHENTICATED';
          break;
        default:
          message = errorDesc || 'An error occurred';
      }
    } else {
      message = (error.description || 'An unknown error occurred');
    }
    yield put(getLoanMaturityReportFailure(message));
  }
}
/**
 * Watchers
 */
export function* watchGetLoans() {
  yield takeEvery(GET_LOANS, getLoansSaga);
}

export function* watchGet60DayLoans() {
  yield takeEvery(GET_60_DAY_LOANS, get60DayLoansSaga);
}

export function* watchGetCashFlowLoans() {
  yield takeEvery(GET_CASH_FLOW_LOANS, getCashFlowLoans);
}

export function* watchGetLoan() {
  yield takeEvery(GET_LOAN, getLoanSaga);
}

export function* watchGetMaturityReport() {
  yield takeEvery(GET_LOAN_MATURITY_REPORT, getMaturityReportSaga);
};

function* LoanSaga() {
  yield all([
    fork(watchGetLoans),
    fork(watchGet60DayLoans),
    fork(watchGetCashFlowLoans),
    fork(watchGetLoan),
    fork(watchGetMaturityReport),
  ]);
}

export default LoanSaga;
